module.exports = __webpack_public_path__ + "img/box-title-3.36ead253.png";